/* eslint-disable */

import { Loader } from '@lideralia/alife-uikit/dist/atoms/Loader';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { KEYS_ANALYTICS, setEventAnalytics } from '../../../common/components/Analytics';
import { getLocalStorage } from '../../../common/functions/cookies';
import { actualLanguage } from '../../../common/functions/lang';
import { resetBranchOrder } from '../../../common/schemes/branch_order';
import { getCertificateTree, resetOrder } from '../../../common/schemes/order/actions';
import { resetServiceCompanyOrder } from '../../../common/schemes/service_company_order/actions';
import { resetServiceProductOrder } from '../../../common/schemes/service_product_order/actions';
import { BranchOrderResumeTemplate } from '../template';
import { ServiceOrderResumeTemplate } from '../template/ServiceOrderResumePage';
import { TreeOrderResumeTemplate } from '../template/TreeOrderResumePage';


const STORE_PRODUCT = "App\\Models\\StoreProduct";
const TREE_PRODUCT = "App\\Models\\Tree";
const SERVICE_PRODUCT = "App\\Models\\ServiceProduct";
const SERVICE_COMPANY = "App\\Models\\ServiceCompany";

const OrderSummaryPage = ({ history }) => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user);
  const branchOrder = useSelector((state) => state.branch_order);
  const orders = useSelector((state) => state.order);
  const serviceProductOrder = useSelector((state) => state.serviceProductOrder);
  const serviceCompanyOrder = useSelector((state) => state.serviceCompanyOrder);
  const setResetBranchOrder = useCallback(() => dispatch(resetBranchOrder()));
  const setResetOrder = useCallback(() => dispatch(resetOrder()));
  const setResetServiceProductOrder = useCallback(() => dispatch(resetServiceProductOrder()), [dispatch]);
  const setResetServiceCompanyOrder = useCallback(() => dispatch(resetServiceCompanyOrder()), [dispatch]);
  const getCertificateTreeAPI = useCallback((data) => dispatch(getCertificateTree(data)), [dispatch]);
  const [order, setOrder] = useState(null);
  const [tree_order, setTreeOrder] = useState(null);
  const line = useSelector((state) => state.line);
  const { idLine, idName } = useParams();
  const idLineStored = getLocalStorage(process.env.REACT_APP_COOKIE_ID_LINE);
  const idNameStored = getLocalStorage(process.env.REACT_APP_COOKIE_NAME_LINE);
  const [lineDefault, setLineDefault] = useState(idLine || idLineStored);
  const [nameDefault, setNameDefault] = useState(idName || idNameStored);
  const [idActive, setIdActive] = useState(idLineStored || null);
  const { active } = line;

  const goHome = () => {
    const toBack = idActive ? `/${actualLanguage}/lines/${idActive}/${idNameStored}/ceremony` : `/${actualLanguage}/lines`
    history.push(`${toBack}`);
  };

  const viewTree = () => {
    const toTree = `/${actualLanguage}/lines/${lineDefault || idLineStored}/${
      nameDefault || idNameStored
    }/services/udianas/${tree_order?.orderable.tree_product.id}/description?project=${tree_order?.orderable.tree_product.reforestation_project_hash_id}&tree_uuid=${
      tree_order.orderable.uuid
    }`;

    history.push(`${toTree}`);
  };

  const getCertificate = () => {
    getCertificateTreeAPI({ uuid: order.orderable.uuid });
    setEventAnalytics(
      KEYS_ANALYTICS.UDIANAS_CERTIFICATE_DOWNLOAD_BUTTON_CLICKED,
      user,
      history?.location?.pathname,
      active,
      { tree_uuid: order.orderable.uuid }
    );
  }

  useEffect(() => {
    if(Object.keys(orders?.data).length > 0){
      if (orders?.data && orders?.data?.status === 'success') {
        setEventAnalytics(KEYS_ANALYTICS.UDIANAS_ORDER_COMPLETED, user, history?.location?.pathname, active);
        setOrder(orders.data);
        
        // Filter child_orders for TREE_PRODUCT type
        if (orders.data.child_orders && Array.isArray(orders.data.child_orders)) {
          const treeOrder = orders.data.child_orders.find(childOrder => 
            childOrder.orderable_type === TREE_PRODUCT
          );
          setTreeOrder(treeOrder || null);
        }
        
        setResetOrder();
      } else if (order === null) {
        goHome();
      }
    }

    if(Object.keys(branchOrder?.info).length > 0){
      if (branchOrder?.info && branchOrder?.info?.status === 'success') {
        setEventAnalytics(KEYS_ANALYTICS.ECOMMERCE_ORDER_COMPLETED, user, history?.location?.pathname, active);
        setOrder(branchOrder.info);
        
        // Filter child_orders for TREE_PRODUCT type
        if (branchOrder.info.child_orders && Array.isArray(branchOrder.info.child_orders)) {
          const treeOrder = branchOrder.info.child_orders.find(childOrder => 
            childOrder.orderable_type === TREE_PRODUCT
          );
          setTreeOrder(treeOrder || null);
        }
        
        setResetBranchOrder();
      } else if (order === null) {
        goHome();
      }
    }

    if(serviceProductOrder?.info && serviceProductOrder?.done){
      if (serviceProductOrder.info.status === 'success') {
        setEventAnalytics(KEYS_ANALYTICS.SERVICE_PRODUCT_ORDER_COMPLETED, user, history?.location?.pathname, active);
        setOrder(serviceProductOrder.info);
        
        // Reset serviceProductOrder después de procesar la orden exitosa
        setResetServiceProductOrder();
      }
    }

    if(serviceCompanyOrder?.info && serviceCompanyOrder?.done){
      if (serviceCompanyOrder.info.status === 'success') {
        setEventAnalytics(KEYS_ANALYTICS.SERVICE_COMPANY_ORDER_COMPLETED, user, history?.location?.pathname, active);
        setOrder(serviceCompanyOrder.info);
        
        // Reset serviceCompanyOrder después de procesar la orden exitosa
        setResetServiceCompanyOrder();
      }
    }
  }, [branchOrder, orders, serviceProductOrder, serviceCompanyOrder]);

  if (order === null || Object.keys(order).length === 0) {
    return <Loader/>
  }

  if(order.orderable_type === STORE_PRODUCT) return <BranchOrderResumeTemplate goHome={goHome} viewTree={viewTree} branch_order={order} hasTreeOrder={!!tree_order} />;

  if(order.orderable_type === SERVICE_PRODUCT || order.orderable_type === SERVICE_COMPANY) return <ServiceOrderResumeTemplate goHome={goHome} order={order} />;

  return <TreeOrderResumeTemplate goHome={goHome} order={order} getCertificate={getCertificate} />;
};

export default OrderSummaryPage;

OrderSummaryPage.propTypes = {};
